import { useSelector } from 'react-redux';
import { selectWarehouses } from 'redux/selectors';
import { useActions } from 'hooks/redux/useActions';
import {
  setWarehouses,
  setWarehousesIfEmpty,
  unsetWarehouses,
} from 'redux/reducers/warehouses-reducer';

export function useWarehouses() {
  const { items: warehouses, status: warehousesStatus } =
    useSelector(selectWarehouses);
  const actions = useActions({
    setWarehouses,
    unsetWarehouses,
    setWarehousesIfEmpty,
  });

  return { warehouses, warehousesStatus, ...actions };
}
